import { render, staticRenderFns } from "./submission.judging.vue?vue&type=template&id=2953aaf8&scoped=true&"
import script from "./submission.judging.vue?vue&type=script&lang=js&"
export * from "./submission.judging.vue?vue&type=script&lang=js&"
import style0 from "./submission.judging.vue?vue&type=style&index=0&id=2953aaf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2953aaf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
